import React, { ReactElement, useEffect } from 'react';
import { Header } from '@epo/epods-react-components/lib/Components/Header-next';
import { actions } from '../../../../slice';
import { useDispatch } from 'react-redux';
import { languages } from './helper';
import { useTranslation } from 'react-i18next';

const WrappedAppbar = (): ReactElement => {
    const [t, i18n] = useTranslation();
    const dispatch = useDispatch();
    const { setLanguage } = actions;

    const handleLanguageSelect = (e: any) => {
        const language = languages[e.target.textContent.trim()];
        localStorage.setItem('lang', language);
        i18n.changeLanguage(language);
        localStorage.setItem('i18nextLng', language);
        dispatch(setLanguage(language));
    };

    const lang = localStorage.getItem('i18nextLng');

    useEffect(() => {
        const divInsideButton = document.querySelector('#epo-dropdownpanel button div');

        if (lang) {
            // @ts-ignore
            divInsideButton.textContent = lang.toUpperCase();
        }
    }, [lang]);
    
    return (
        <div
            style={{
                height: '60px',
                width: '100%',
                position: 'fixed',
                zIndex: '99999',
            }}
            id="epo-dropdownpanel"
        >
            <Header
                epoLogo
                languageSelector
                onClickLanguageSelector={handleLanguageSelect}
                epoLogoSrcPath="img/logo.svg"
                epoLogoTargetUrl="https://epo.org/"
                productName={t('SITE_TITLE')}
            />
        </div>
    );
};

export default WrappedAppbar;
